<fieldset class="question-fieldset mb-4 w-100" 
    [ngClass]="{'disabled': radioGroupSettings.disabled}">
    <legend class="question-legend">
        <span *ngIf="isMobileDevice()">
            {{radioGroupSettings.shortCaption| translate }}
        </span>
        <span *ngIf="!isMobileDevice()">
            {{radioGroupSettings.caption | translate }}
        </span>
    </legend>
    <div class="question-fieldset-content d-flex justify-content-end">
        <div class="form-check form-check-inline">
            <span [ngClass]="{'pointer-events-none' : radioGroupSettings.disabled}">
                <input
                    [id]="'radioTrue_' + radioGroupSettings.radioKey"
                    class="form-check-input"
                    type="radio"
                    name="radioGroup{{groupkey}}"
                    [(ngModel)]="bindModel"
                    [value]="true"
                    (change)="radioValueChanged()" />
                <label 
                    [for]="'radioTrue_' + radioGroupSettings.radioKey"
                    class="form-check-label">
                    {{'GLOBAL.YES' | translate }}
                </label>
            </span>            
        </div>
        <div class="form-check form-check-inline">
            <span [ngClass]="{'pointer-events-none' : radioGroupSettings.disabled}">
                <input
                    [id]="'radioFalse_' + radioGroupSettings.radioKey"
                    class="form-check-input"
                    type="radio"
                    name="radioGroup{{groupkey}}"
                    [(ngModel)]="bindModel"
                    [value]="false"
                    (change)="radioValueChanged()" />
                <label 
                    [for]="'radioFalse_' + radioGroupSettings.radioKey"
                    class="form-check-label">
                    {{'GLOBAL.NO' | translate }}
                </label>
            </span>            
        </div>
        <span [ngClass]="{'pointer-events-none' : radioGroupSettings.disabled}">
            <app-cea-help-button 
                [stype]="'radio'"
                [title]="radioGroupSettings?.helpSlug.title"
                [text1]="radioGroupSettings?.helpSlug.text">
            </app-cea-help-button>
        </span>        
    </div>
</fieldset>